import Content from "@/pages/home";
import Ecological from "@/pages/ecological";
import DocumentResources from "@/pages/documentResources";
import Resource from "@/pages/resource";
import ServiceSupport from "@/pages/serviceSupport";
import Design from "@/pages/design";
import Develop from "@/pages/develop";
import Document from "@/pages/document";
import DesignStory from "@/pages/designStory";
import Staging from "@/pages/staging";
import AppList from "@/pages/appList";
import AppDetail from "@/pages/appDetail";
import Info from "@/pages/appDetail/info";
import VersionManage from "@/pages/appDetail/versionManage";
import Profile from "@/pages/appDetail/profile";
import DistributionBoard from "@/pages/appDetail/distributionBoard";
import UserBoard from "@/pages/appDetail/userBoard";
import RulesList from "@/pages/rulesList";
import RulesDetail from "@/pages/rulesDetail";
import RulesInfo from "@/pages/rulesDetail/info";
import RulesVersionManage from "@/pages/rulesDetail/versionManage";
import SuperDeviceTemplate from "@/pages/superDeviceTemplate";
import SuperDeviceTemplateDetail from "@/pages/superDeviceTemplateDetail";
import SuperDeviceTemplateInfo from "@/pages/superDeviceTemplateDetail/info";
import SuperObjectModel from "@/pages/superDeviceTemplateDetail/superObjectModel";
import SpatialInformation from "@/pages/superDeviceTemplateDetail/spatialInformation";
import BusinessRules from "@/pages/superDeviceTemplateDetail/businessRules";

import MyAiModel from "@/pages/myAiModel";
import MyAiModelDetail from "@/pages/myAiModelDetail";
import MyAiModelDetailInfo from "@/pages/myAiModelDetail/info";
import MyAiModelDetailVersionManage from "@/pages/myAiModelDetail/versionManage";
import MyAiModelDistributionBoard from "@/pages/myAiModelDetail/distributionBoard";
import MyAiModelUserBoard from "@/pages/myAiModelDetail/userBoard";
import MyDevicePlugin from "@/pages/myDevicePlugin";
import ProductManage from "@/pages/productManage";
import ProductDetail from "@/pages/productDetail";
import ProductDetailInfo from "@/pages/productDetail/info";
import PhysicalModel from "@/pages/productDetail/physicalModel";
import DevicePlugin from "@/pages/productDetail/devicePlugin";
import MyDevicePluginDetail from "@/pages/myDevicePluginDetail";
import MyDevicePluginDetailInfo from "@/pages/myDevicePluginDetail/info";
import MyDevicePluginDetailVersionManage from "@/pages/myDevicePluginDetail/versionManage";
import MySolution from "@/pages/mySolution";
import MySolutionDetail from "@/pages/mySolutionDetail";
import MySolutionDetailInfo from "@/pages/mySolutionDetail/info";
import MySolutionDetailVersionManage from "@/pages/mySolutionDetail/versionManage";
import ProtocolPlugin from "@/pages/protocolPlugin";
import ToolBox from "@/pages/toolBox";

const Home = [
  {
    name: "",
    path: "",
    component: <Staging />,
  },
  // {
  //   name: "Home",
  //   path: "home",
  //   component: <Content />,
  // },
  {
    name: "Ecological",
    path: "ecological",
    component: <Ecological />,
  },
  {
    name: "DocumentResources",
    path: "document_resources",
    component: <DocumentResources />,
  },
  {
    name: "Resource",
    path: "resource",
    component: <Resource />,
  },
  {
    name: "ServiceSupport",
    path: "service_support",
    component: <ServiceSupport />,
  },
  {
    name: "Design",
    path: "design",
    component: <Design />,
  },
  {
    name: "Develop",
    path: "develop",
    component: <Develop />,
  },
  {
    name: "Document",
    path: "document",
    component: <Document />,
  },
  {
    name: "DesignStory",
    path: "design_story",
    component: <DesignStory />,
  },
  {
    name: "Staging",
    path: "staging",
    component: <Staging />,
  },
  {
    name: "AppList",
    path: "app_list/:type",
    component: <AppList />,
  },
  {
    name: "AppDetail",
    path: "app_detail",
    component: <AppDetail />,
    children: [
      {
        name: "Info",
        path: "info/:type/:id",
        component: <Info />,
      },
      {
        name: "VersionManage",
        path: "versionmanage/:type/:id",
        component: <VersionManage />,
      },
      {
        name: "Profile",
        path: "profile/:type/:id",
        component: <Profile />,
      },
      {
        name: "DistributionBoard",
        path: "distribution_board/:type/:id",
        component: <DistributionBoard />,
      },
      {
        name: "UserBoard",
        path: "user_board/:type/:id",
        component: <UserBoard />,
      },
    ],
  },
  {
    name: "RulesList",
    path: "rules_list",
    component: <RulesList />,
  },
  {
    name: "RulesDetail",
    path: "rules_detail",
    component: <RulesDetail />,
    children: [
      {
        name: "Info",
        path: "info/:id",
        component: <RulesInfo />,
      },
      {
        name: "VersionManage",
        path: "versionmanage/:id",
        component: <RulesVersionManage />,
      },
    ],
  },
  {
    name: "SuperDeviceTemplate",
    path: "super_device_template",
    component: <SuperDeviceTemplate />,
  },
  {
    name: "SuperDeviceTemplateDetail",
    path: "super_device_template_detail",
    component: <SuperDeviceTemplateDetail />,
    children: [
      {
        name: "Info",
        path: "info/:id",
        component: <SuperDeviceTemplateInfo />,
      },
      {
        name: "SuperObjectModel",
        path: "superobjectmodel/:id",
        component: <SuperObjectModel />,
      },
      {
        name: "SpatialInformation",
        path: "spatialinformation/:id",
        component: <SpatialInformation />,
      },
      {
        name: "BusinessRules",
        path: "businessrules/:id",
        component: <BusinessRules />,
      },
    ],
  },
  {
    name: "AiModel",
    path: "my_ai_model/:typeKey",
    component: <MyAiModel />,
  },
  {
    name: "Agent",
    path: "my_ai_model/:typeKey",
    component: <MyAiModel />,
  },
  {
    name: "MyAiModelDetail",
    path: "my_ai_model_detail",
    component: <MyAiModelDetail />,
    children: [
      {
        name: "Info",
        path: "info/:typeKey/:id",
        component: <MyAiModelDetailInfo />,
      },
      {
        name: "VersionManage",
        path: "versionmanage/:typeKey/:id",
        component: <MyAiModelDetailVersionManage />,
      },
      {
        name: "MyAiModelDistributionBoard",
        path: "distribution_board/:typeKey/:id",
        component: <MyAiModelDistributionBoard />,
      },
      {
        name: "MyAiModelUserBoard",
        path: "user_board/:typeKey/:id",
        component: <MyAiModelUserBoard />,
      },
    ],
  },
  {
    name: "MySolution",
    path: "my_solution",
    component: <MySolution />,
  },
  {
    name: "MySolutionDetail",
    path: "my_solution_detail",
    component: <MySolutionDetail />,
    children: [
      {
        name: "Info",
        path: "info/:id",
        component: <MySolutionDetailInfo />,
      },
      {
        name: "VersionManage",
        path: "versionmanage/:id/:versionId",
        component: <MySolutionDetailVersionManage />,
      },
    ],
  },
  {
    name: "MyDevicePlugin",
    path: "my_device_plugin",
    component: <MyDevicePlugin />,
  },
  {
    name: "MyDevicePluginDetail",
    path: "my_device_plugin_detail",
    component: <MyDevicePluginDetail />,
    children: [
      {
        name: "Info",
        path: "info/:id",
        component: <MyDevicePluginDetailInfo />,
      },
      {
        name: "VersionManage",
        path: "versionmanage/:id",
        component: <MyDevicePluginDetailVersionManage />,
      },
    ],
  },
  {
    name: "ProductManage",
    path: "product_manage",
    component: <ProductManage />,
  },
  {
    name: "ProductDetail",
    path: "product_detail",
    component: <ProductDetail />,
    children: [
      {
        name: "Info",
        path: "info/:id",
        component: <ProductDetailInfo />,
      },
      {
        name: "PhysicalModel",
        path: "physical_model/:id",
        component: <PhysicalModel />,
      },
      {
        name: "DevicePlugin",
        path: "device_plugin/:id",
        component: <DevicePlugin />,
      },
    ],
  },
  {
    name: "ProtocolPlugin",
    path: "protocol_plugin",
    component: <ProtocolPlugin />,
  },
  {
    name: "ToolBox",
    path: "tool_box",
    component: <ToolBox />,
  },
];

export default Home;
